import { client } from "./supabase";

// ─── COMPROMISOS DE PAGO (egreso futuro a un proveedor SIN factura todavía) ────
//
// Molde: src/utils/activos.js. El "compromiso de pago" es la entidad HERMANA liviana
// de CapEx (ver docs/dominios/compromisos-pago.md): un gasto/costo directo a un
// proveedor conocido de entrada, sin depreciación ni destino_* ni ER de activo fijo.
// Tabla compromisos_pago (Fase 1, migración 20260816_compromisos_pago.sql).
// Todo por ID (10.7). Filtro de país (10.10/10.53). Soft-delete, nunca delete físico (10.114).
// Errores se propagan (throw), nunca se tragan a [] (10.170/10.177).

// Lista los compromisos de un país. Embebe proveedor (nombre) y la factura ligada (si ya
// se asoció), igual que getActivos. Por defecto excluye los eliminados (soft-delete); el
// caller puede pedir incluirlos. Orden por fecha_estimada desc (la fecha operativa del
// compromiso, análoga a activos.fecha_compra).
export const getCompromisos = async (pais, { incluirEliminados = false } = {}) => {
  let query = client
    .from("compromisos_pago")
    .select(
      `
      *,
      proveedor:proveedores(id, nombre),
      factura_sii:facturas_sii_recibidas(id, folio, razon_social_emisor)
    `
    )
    .eq("pais", pais)
    .order("fecha_estimada", { ascending: false });

  if (!incluirEliminados) query = query.eq("eliminado", false);

  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

// Alta de un compromiso. Nace estado='planificado' + eliminado=false. created_by lo trae el
// caller con el id del usuario REAL (10.104) — este util no lo hardcodea. Cualquier campo
// pasado en `compromiso` pisa los defaults (p.ej. estado, si algún día se necesitara otro).
// proveedor_id es OPCIONAL (nullable desde 20260823): el alta suelta desde el header de
// FlujoCajaV2 puede crear un compromiso sin proveedor; el caller pasa proveedor_id: null.
export const crearCompromiso = async (compromiso) => {
  const { data, error } = await client
    .from("compromisos_pago")
    .insert({ estado: "planificado", eliminado: false, ...compromiso })
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const actualizarCompromiso = async (id, cambios) => {
  const { data, error } = await client
    .from("compromisos_pago")
    .update({ ...cambios, updated_at: new Date().toISOString() })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

// Baja SIEMPRE lógica (eliminado=true). NUNCA delete físico: un compromiso puede tener
// cuotas pagadas atadas a un movimiento bancario histórico (plan_pagos_compromiso). Espejo
// de eliminarActivo.
export const eliminarCompromiso = async (id) => {
  const { error } = await client
    .from("compromisos_pago")
    .update({ eliminado: true, updated_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
};
